<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from 'svelte-i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';

	//Svelte hooks
	import { onMount } from 'svelte';

	//Stores

	//Helpers
	import { getSettingUiComponent, get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	import { onSettingsResponse } from '../../../../helpers/device_settings_helpers';

	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';

	//Design system components
	import { Checkbox, Text } from '@Shelly/shelly-design-system';

	//Components
	import NightSchedule from '../../NightMode/NightModeComponents/NightSchedule.svelte';
	import NightModeList from '../../NightMode/NightModeComponents/NightModeList.svelte';

	export let device;

	const id = real_id(device.id),
		settings = readDeviceSettings(id),
		plugUi = getSettingUiComponent(device);

	const nightMode = settings?.[plugUi].leds.night_mode;

	if (
		(Array.isArray(nightMode['active_between']) && nightMode['active_between'].length < 1) ||
		!Array.isArray(nightMode['active_between'])
	) {
		nightMode['active_between'] = ['00:00', '00:00'];
	}

	let config = settings?.[plugUi],
		checked = settings?.[plugUi].leds.night_mode.enable,
		props = {
			start: nightMode['active_between'][0],
			end: nightMode['active_between'][1],
			brightness: nightMode.brightness,
		},
		showModal = false,
		local_ip;

	onMount(() => {
		local_ip = get_local_ip(id);
	});

	const setNightMode = async () => {
		config = {
			leds: {
				night_mode: {
					enable: checked,
					active_between: [props.start, props.end],
					brightness: props.brightness,
				},
			},
		};

		const params = {
			id: device.channel,
			config: config,
		};

		const res: SettingRequest = await gen2Request(device, `${plugUi}.SetConfig`, params);
		onSettingsResponse(res, device);
	};

	const handleToggler = async (e) => {
		checked = !checked;
		setNightMode();
	};

	const handleSave = (e) => {
		const _nightMode = { ...e.detail };
		nightMode.active_between = [_nightMode.start, _nightMode.end];
		nightMode.brightness = _nightMode.brightness;
		setNightMode();
		props = {
			start:
				typeof nightMode['active_between'][0] !== 'object'
					? nightMode['active_between'][0]
					: '00:00',
			end:
				typeof nightMode['active_between'][1] !== 'object'
					? nightMode['active_between'][1]
					: '00:00',
			brightness: nightMode.brightness,
		};
	};
</script>

<Checkbox class="mb-s" size="m" {checked} on:click={handleToggler} id="checkbox-708xp5o"
	>{$format('label_enable_night_mode')}</Checkbox
>
<Text class="mb-s" element="h3">{$format('active_nigthmode')}</Text>
{#key nightMode.active_between || checked}
	<NightModeList disabled={!checked} {nightMode} on:edit={() => (showModal = true)} />
{/key}

{#if showModal}
	<NightSchedule bind:props bind:showModal on:save={handleSave} />
{/if}
